import axiosInstance from "../utils/axios"

export const sectorService = {
  fetchAllWithoutPaginate: async () => {
    const response = await axiosInstance.get('/sectoral/all')
    return response.data
  },
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/sectoral',{ params })
    return response.data
  },
  findById: async (id) => {
    const response = await axiosInstance.get('/sectoral/'+id)
    return response.data
  },
  store: async (data) => {
    const response = await axiosInstance.post('/sectoral', data)
    return response.data
  },
  update: async (id, data) => {
    const response = await axiosInstance.put(`/sectoral/${id}`, data);
    return response.data;
  },  
  delete: async (id) => {
    const response = await axiosInstance.delete(`/sectoral/${id}`)
    return response.data
  },
}
